export default "__VITE_ASSET__BAJYnZnH__"